// tippi/src/pages/carrier/carrierStyles.js
import { COLORS, FONTS } from '../../styles/tokens';

const TONES = {
  ok:      [COLORS.successText, COLORS.successBg],
  soon:    [COLORS.warningText, COLORS.warningBg],
  expired: [COLORS.dangerText, COLORS.dangerBg],
  none:    [COLORS.textMid, COLORS.surfaceHover],
  info:    [COLORS.blueText, COLORS.blueBg],
};

// Liten statusmerkelapp. tone: ok | soon | expired | none | info
export const chip = (tone = 'none') => ({
  display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700,
  color: TONES[tone][0], background: TONES[tone][1],
});

export const ui = {
  root:  { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: COLORS.bg, fontFamily: FONTS.body, color: COLORS.textDark },
  tabs:  { display: 'flex', gap: 4, overflowX: 'auto', padding: '8px 12px', background: COLORS.brandPanel, flexShrink: 0 },
  main:  { flex: 1, width: '100%', maxWidth: 960, margin: '0 auto', padding: '16px 16px 48px', boxSizing: 'border-box' },
  h1:    { fontFamily: FONTS.display, fontSize: 32, lineHeight: 1.1, margin: '8px 0 16px' },
  h2:    { fontSize: 16, fontWeight: 700, margin: '0 0 10px' },
  card:  { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 14, padding: 16, marginBottom: 14 },
  row:   { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' },
  grid:  { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 14 },
  stat:  { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 14, padding: '14px 16px' },
  statNumber: { fontFamily: FONTS.display, fontSize: 36, lineHeight: 1 },
  label: { display: 'block', fontSize: 12, fontWeight: 600, color: COLORS.textMid, margin: '10px 0 5px' },
  input: { width: '100%', boxSizing: 'border-box', height: 44, padding: '0 12px', borderRadius: 12, border: `1px solid ${COLORS.border}`, fontSize: 15, fontFamily: 'inherit', background: COLORS.white, color: COLORS.textDark },
  btn:   { height: 44, padding: '0 20px', borderRadius: 22, border: 'none', background: COLORS.accent, color: '#1a1a2e', fontSize: 15, fontWeight: 700, cursor: 'pointer' },
  btnSecondary: { height: 44, padding: '0 18px', borderRadius: 22, border: `1.5px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnDanger: { height: 38, padding: '0 14px', borderRadius: 19, border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerBg, color: COLORS.dangerText, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  link:  { color: COLORS.textDark, textDecoration: 'none' },
  listRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderBottom: `1px solid ${COLORS.border}` },
  error: { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '10px 12px', borderRadius: 10, fontSize: 14, margin: '12px 0 0' },
  ok:    { background: COLORS.successBg, color: COLORS.successText, padding: '10px 12px', borderRadius: 10, fontSize: 14, margin: '12px 0 0' },
  fieldError: { fontSize: 12, color: COLORS.dangerText, marginTop: 4 },
  hint:  { fontSize: 13, color: COLORS.textMid, lineHeight: 1.5 },
};
